(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-submission"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EXPECTED_FORM_ID = '1049020';
    let generatedUploadId = 0;

    const getFieldWrapper = (field, form) => {
      let current = field.parentElement;

      while (current && current !== form) {
        const containsLabel = current.querySelector('label');
        const nestedFields = current.querySelectorAll(
          'input, select, textarea'
        );

        if (containsLabel && nestedFields.length === 1) {
          return current;
        }

        current = current.parentElement;
      }

      return field.parentElement;
    };

    const markShopifyFormLayout = (root) => {
      root.querySelectorAll('form').forEach((form) => {
        form.classList.add('event-form');

        form
          .querySelectorAll('input, select, textarea')
          .forEach((field) => {
            const type = (
              field.getAttribute('type') || ''
            ).toLowerCase();

            if (
              type === 'hidden' ||
              type === 'submit' ||
              type === 'button'
            ) {
              return;
            }

            const wrapper = getFieldWrapper(field, form);
            if (!wrapper) return;

            const labelText = (
              wrapper.querySelector('label')?.textContent || ''
            )
              .replace(/\s+/g, ' ')
              .trim()
              .toLowerCase();

            if (type === 'checkbox' || type === 'radio') {
              wrapper.classList.add(
                'event-form-consent',
                'event-form-field--wide'
              );
              return;
            }

            wrapper.classList.add('event-form-field');

            const shouldBeWide =
              field.matches(
                'textarea, input[type="file"], input[type="url"]'
              ) ||
              labelText.includes('analytics screenshot') ||
              labelText.includes('paypal email') ||
              labelText.includes('notes');

            if (shouldBeWide) {
              wrapper.classList.add('event-form-field--wide');
            }
          });

        form
          .querySelectorAll(
            'button[type="submit"], input[type="submit"]'
          )
          .forEach((submit) => {
            const wrapper = submit.parentElement;
            if (!wrapper) return;

            wrapper.classList.add(
              'event-form-actions',
              'event-form-field--wide'
            );
          });
      });
    };

    const enhanceAppUploads = (root) => {
      root
        .querySelectorAll('input[type="file"]')
        .forEach((input) => {
          if (input.closest('[data-event-upload]')) return;

          let shell = input.nextElementSibling;

          if (!shell?.matches('[data-event-generated-upload]')) {
            if (!input.id) {
              generatedUploadId += 1;
              input.id = `EventAppUpload-${generatedUploadId}`;
            }

            shell = document.createElement('div');
            shell.className =
              'event-upload-shell event-upload-shell--generated';
            shell.setAttribute(
              'data-event-generated-upload',
              ''
            );

            shell.innerHTML = `
              <label class="event-upload-control" for="${input.id}">
                <span class="event-upload-visual" aria-hidden="true">
                  <span class="event-upload-icon">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect
                        x="3"
                        y="3"
                        width="18"
                        height="18"
                        rx="2"
                      ></rect>
                      <circle
                        cx="8.5"
                        cy="8.5"
                        r="1.5"
                      ></circle>
                      <path d="m21 15-5-5L5 21"></path>
                    </svg>
                  </span>

                  <img
                    class="event-upload-preview"
                    alt=""
                    width="54"
                    height="54"
                    hidden
                    data-event-upload-preview
                  >
                </span>

                <span class="event-upload-copy">
                  <strong>Add analytics screenshot</strong>
                  <span>PNG, JPG or WEBP</span>
                </span>

                <span
                  class="event-upload-action"
                  data-event-upload-action
                >
                  <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M12 5v14M5 12h14"></path>
                  </svg>

                  <span>Choose image</span>
                </span>
              </label>

              <div class="event-upload-meta">
                <p
                  class="event-upload-file"
                  data-event-upload-file
                  aria-live="polite"
                >
                  No image selected
                </p>

                <button
                  class="event-upload-clear"
                  type="button"
                  hidden
                  data-event-upload-clear
                >
                  <svg
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M18 6 6 18M6 6l12 12"></path>
                  </svg>

                  <span>Remove</span>
                </button>
              </div>
            `;

            input.insertAdjacentElement('afterend', shell);
          }

          input.classList.add(
            'event-upload-input',
            'event-upload-input--app'
          );

          if (
            !input.hasAttribute('data-event-upload-input')
          ) {
            input.setAttribute(
              'data-event-upload-input',
              ''
            );
          }

          const fieldWrapper = getFieldWrapper(
            input,
            input.form
          );

          fieldWrapper?.classList.add(
            'event-form-field',
            'event-form-field--wide'
          );
        });
    };

    const enhanceUpload = (root) => {
      root
        .querySelectorAll('[data-event-upload-input]')
        .forEach((input) => {
          if (input.dataset.uploadReady === 'true') {
            return;
          }

          const shell =
            input.closest('.event-upload-shell') ||
            input.nextElementSibling;

          const fileName = shell?.querySelector(
            '[data-event-upload-file]'
          );

          const preview = shell?.querySelector(
            '[data-event-upload-preview]'
          );

          const action = shell?.querySelector(
            '[data-event-upload-action] span:last-child'
          );

          const clear = shell?.querySelector(
            '[data-event-upload-clear]'
          );

          if (
            !shell?.matches('.event-upload-shell') ||
            !fileName
          ) {
            return;
          }

          let previewUrl = '';

          const syncFileName = () => {
            const selectedFile =
              input.files && input.files[0];

            if (previewUrl) {
              URL.revokeObjectURL(previewUrl);
              previewUrl = '';
            }

            fileName.textContent = selectedFile
              ? selectedFile.name
              : 'No image selected';

            shell.classList.toggle(
              'has-file',
              Boolean(selectedFile)
            );

            if (preview) {
              if (
                selectedFile?.type.startsWith('image/')
              ) {
                previewUrl =
                  URL.createObjectURL(selectedFile);

                preview.src = previewUrl;
                preview.hidden = false;
              } else {
                preview.removeAttribute('src');
                preview.hidden = true;
              }
            }

            if (action) {
              action.textContent = selectedFile
                ? 'Replace image'
                : 'Choose image';
            }

            if (clear) {
              clear.hidden = !selectedFile;
            }
          };

          input.dataset.uploadReady = 'true';

          input.addEventListener(
            'change',
            syncFileName
          );

          clear?.addEventListener('click', () => {
            input.value = '';
            syncFileName();
            input.focus();
          });

          input.form?.addEventListener('reset', () => {
            setTimeout(syncFileName, 0);
          });

          syncFileName();
        });
    };

    const validateConfiguredForm = (root) => {
      const formsRoot = root.querySelector(
        '[data-forms-id]'
      );

      const actualFormId =
        formsRoot?.getAttribute('data-forms-id');

      if (
        actualFormId &&
        actualFormId !== EXPECTED_FORM_ID &&
        window.Shopify?.designMode
      ) {
        console.warn(
          `[FASTSPORT Ride Drop] Expected Shopify Forms ID ${EXPECTED_FORM_ID}, but found ${actualFormId}.`
        );
      }
    };

    const enhanceFormApp = (app) => {
      markShopifyFormLayout(app);
      enhanceAppUploads(app);
      enhanceUpload(app);
      validateConfiguredForm(app);
    };

    const initialize = (scope = document) => {
      scope
        .querySelectorAll('[data-event-form-app]')
        .forEach((app) => {
          if (
            app.dataset.eventObserverReady === 'true'
          ) {
            enhanceFormApp(app);
            return;
          }

          app.dataset.eventObserverReady = 'true';
          enhanceFormApp(app);

          const observer = new MutationObserver(() => {
            enhanceFormApp(app);
          });

          observer.observe(app, {
            childList: true,
            subtree: true
          });

          setTimeout(
            () => enhanceFormApp(app),
            300
          );

          setTimeout(
            () => enhanceFormApp(app),
            1000
          );

          setTimeout(
            () => enhanceFormApp(app),
            2500
          );
        });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialize()
      );
    } else {
      initialize();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initialize(event.target);
      }
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        initialize(
          event.target.closest('.shopify-section') ||
            document
        );
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fastsport-home-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const viewerScript = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';

    const ensureModelViewer = () => {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (window.fastSportModelViewerPromise) return window.fastSportModelViewerPromise;

      window.fastSportModelViewerPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = viewerScript;
        script.onload = () => customElements.whenDefined('model-viewer').then(resolve);
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return window.fastSportModelViewerPromise;
    };

    const initialize = (section) => {
      if (!section || section.dataset.fs3dReady === 'true') return;
      section.dataset.fs3dReady = 'true';

      const viewer = section.querySelector('.fs3d__model');
      const status = section.querySelector('[data-fs3d-status]');
      const progress = section.querySelector('[data-fs3d-progress]');
      const viewButtons = section.querySelectorAll('[data-fs3d-view]');
      const zoomControls = section.querySelector('.fs3d__zoom');
      const zoomButtons = section.querySelectorAll('[data-fs3d-zoom]');
      const hoverVideo = section.querySelector('[data-fs3d-hover-video]');
      const youtubeFrame = section.querySelector('[data-fs3d-youtube]');
      const primarySrc = section.dataset.modelUrl;
      const fallbackSrc = section.dataset.fallbackModelUrl;
      const hoverVideoId = section.dataset.hoverVideoId;
      const canHoverVideo = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      let fallbackTried = false;
      let loadStarted = false;
      let initialRadius = 0;
      let hoverVideoReady = false;
      let soundUnlocked = Boolean(navigator.userActivation && navigator.userActivation.hasBeenActive);

      const youtubeCommand = (func, args = []) => {
        if (!youtubeFrame || !youtubeFrame.contentWindow || !hoverVideoReady) return;
        youtubeFrame.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func,
          args
        }), '*');
      };

      const enableHoverVideoSound = () => {
        soundUnlocked = true;
        if (!hoverVideoReady) return;
        youtubeCommand('unMute');
        youtubeCommand('setVolume', [100]);

        if (section.classList.contains('is-photo') && section.classList.contains('is-video-hover')) {
          youtubeCommand('playVideo');
        }
      };

      const startHoverVideo = () => {
        if (!canHoverVideo || !hoverVideo || !youtubeFrame || !hoverVideoId) return;
        if (!section.classList.contains('is-photo')) return;

        section.classList.add('is-video-hover');

        if (!hoverVideoReady) {
          const params = new URLSearchParams({
            autoplay: '1',
            mute: soundUnlocked ? '0' : '1',
            controls: '0',
            disablekb: '1',
            fs: '0',
            iv_load_policy: '3',
            cc_load_policy: '0',
            loop: '1',
            playlist: hoverVideoId,
            playsinline: '1',
            rel: '0',
            modestbranding: '1',
            enablejsapi: '1'
          });

          youtubeFrame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(hoverVideoId)}?${params.toString()}`;
          hoverVideoReady = true;
          return;
        }

        if (soundUnlocked) {
          youtubeCommand('unMute');
          youtubeCommand('setVolume', [100]);
        }
        youtubeCommand('playVideo');
      };

      const stopHoverVideo = () => {
        section.classList.remove('is-video-hover');
        youtubeCommand('pauseVideo');
      };

      const setActive = (view) => {
        const showingPhoto = view === 'photo';

        if (!showingPhoto) stopHoverVideo();

        section.classList.toggle('is-photo', showingPhoto);
        viewButtons.forEach((button) => {
          const active = button.dataset.fs3dView === view;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        zoomControls.hidden = showingPhoto || !section.classList.contains('is-model-loaded');

        if (showingPhoto && section.matches(':hover')) startHoverVideo();
      };

      const startLoading = async () => {
        if (loadStarted) return;
        loadStarted = true;
        section.classList.add('is-model-loading');
        if (status) status.textContent = 'Loading 3D model';

        try {
          await ensureModelViewer();
          viewer.src = primarySrc;
        } catch (error) {
          section.classList.remove('is-model-loading');
          setActive('photo');
          if (status) status.textContent = '3D unavailable';
        }
      };

      viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const view = button.dataset.fs3dView;
          setActive(view);
          if (view === 'model') startLoading();
        });
      });

      if (canHoverVideo && hoverVideo && youtubeFrame && hoverVideoId) {
        section.addEventListener('mouseenter', startHoverVideo);
        section.addEventListener('mouseleave', stopHoverVideo);

        // Browsers generally block first-time autoplay with sound until the visitor
        // has interacted with the page. After any real user activation, keep this
        // hover video unmuted at full volume without changing the Photo/3D state.
        window.addEventListener('pointerdown', enableHoverVideoSound, { passive: true, once: true });
        window.addEventListener('keydown', enableHoverVideoSound, { once: true });
      }

      zoomButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!section.classList.contains('is-model-loaded')) return;
          const orbit = viewer.getCameraOrbit();
          if (!initialRadius) initialRadius = orbit.radius;
          const factor = button.dataset.fs3dZoom === 'in' ? .86 : 1.16;
          const minimum = initialRadius * .65;
          const maximum = initialRadius * 1.55;
          const nextRadius = Math.min(maximum, Math.max(minimum, orbit.radius * factor));
          viewer.cameraOrbit = `${orbit.theta}rad ${orbit.phi}rad ${nextRadius}m`;
          viewer.jumpCameraToGoal();
        });
      });

      viewer.addEventListener('progress', (event) => {
        if (progress) progress.style.width = `${Math.round(event.detail.totalProgress * 100)}%`;
      });

      viewer.addEventListener('load', () => {
        section.classList.remove('is-model-loading');
        section.classList.add('is-model-loaded');
        initialRadius = viewer.getCameraOrbit().radius;
        if (status) status.textContent = '3D model ready';
        if (progress) progress.style.width = '100%';
        zoomControls.hidden = section.classList.contains('is-photo');
      });

      viewer.addEventListener('error', () => {
        if (!fallbackTried && fallbackSrc) {
          fallbackTried = true;
          if (status) status.textContent = 'Loading backup model';
          if (progress) progress.style.width = '0';
          viewer.src = fallbackSrc;
          return;
        }

        section.classList.remove('is-model-loading');
        setActive('photo');
        if (status) status.textContent = '3D unavailable';
      });

      setActive('photo');
    };

    document.querySelectorAll('[data-fs3d]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-fs3d]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  document.querySelectorAll('.fs-article').forEach((article) => {
    const content = article.querySelector('[data-fs-article-content]');
    const list = article.querySelector('[data-fs-article-toc]');
    const panel = article.querySelector('.fs-article__toc');
    if (!content || !list || !panel) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => {
      return heading.textContent.trim().length > 0;
    }).slice(0, 8);

    const links = headings.map((heading, index) => {
      if (!heading.id) {
        heading.id = `article-section-${index + 1}`;
      }

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.classList.add('is-subsection');

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        heading.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        window.history.replaceState(null, '', `#${heading.id}`);
      });
      item.appendChild(link);
      list.appendChild(item);
      return link;
    });

    if (headings.length > 0) {
      panel.classList.add('has-items');

      let activeId = '';
      const setActive = (id) => {
        if (!id || activeId === id) return;
        activeId = id;

        links.forEach((link, index) => {
          const isActive = headings[index].id === id;
          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }

          if (isActive && window.matchMedia('(max-width: 989px)').matches) {
            list.scrollTo({
              left: link.offsetLeft - ((list.clientWidth - link.offsetWidth) / 2),
              behavior: 'smooth',
            });
          }
        });
      };

      const updateActive = () => {
        const headerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        ) || 0;
        let current = headings[0];

        headings.forEach((heading) => {
          if (heading.getBoundingClientRect().top <= headerHeight + 64) current = heading;
        });

        setActive(current.id);
      };

      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateActive();
          ticking = false;
        });
      }, { passive: true });

      const hashHeading = headings.find((heading) => `#${heading.id}` === window.location.hash);
      setActive(hashHeading ? hashHeading.id : headings[0].id);
      updateActive();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
